export type OlModeProps = { mode: 'ol'; olId: number } | { mode: 'global' }

export class OlModeTable<P extends OlModeProps> {
  constructor(private readonly props: P) {}

  isOl(): this is OlModeTable<{ mode: 'ol'; olId: number }> {
    return this.props.mode === 'ol'
  }

  getOlId(): number | undefined {
    return this.isOl() ? this.props.olId : undefined
  }

  endpoint(cfg: { ol: (olId: number) => string; global: string }): string {
    return this.isOl() ? cfg.ol(this.props.olId) : cfg.global
  }

  columns<C>(base: C[], globalExtra: C[]): C[] {
    return this.isOl() ? base : [...base, ...globalExtra]
  }
}
